import type { ButtonHTMLAttributes } from 'react';

export function PageBackButton({
  className = '',
  label = 'Back',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { label?: string }) {
  return (
    <button
      type="button"
      aria-label={label}
      className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/[0.06] text-[var(--text-secondary)] shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] transition-all duration-150 hover:border-white/16 hover:bg-white/[0.1] hover:text-[var(--text-primary)] active:scale-95 active:bg-white/[0.08] ${className}`}
      {...props}
    >
      <svg
        className="h-5 w-5"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M15 18 9 12l6-6" />
      </svg>
    </button>
  );
}
